import * as DropdownWrapper from './DropdownWrapper'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/dropdown' instead.
 */

export const Dropdown = DropdownWrapper
